import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Play = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.535.565c.32-.188.715-.194 1.04-.014l37.864 20.952a1.048 1.048 0 0 1 0 1.834L3.575 44.288a1.048 1.048 0 0 1-1.555-.917V1.468c0-.371.196-.715.515-.903Zm1.58 2.68v38.35L38.768 22.42 4.115 3.245Z"
  }));
});
Play.displayName = 'Play';
Play.defaultProps = {
  'aria-label': 'Play'
};
export default Play;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Play.js
// module id = 3247
// module chunks = 11